




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';

let DEFAULT_Z_INDEX = 998;

function touchHandler(event: TouchEvent) {
    const touches = event.changedTouches;
    const first = touches[0];
    let type: string = '';

    switch (event.type) {
        case 'touchstart': type = 'mousedown'; break;
        case 'touchmove':  type = 'mousemove'; break;
        case 'touchend':   type = 'mouseup';   break;
        default:           return;
    }

    const simulatedEvent = document.createEvent('MouseEvent');
    simulatedEvent.initMouseEvent(type, true, true, window, 1,
                                  first.screenX, first.screenY,
                                  first.clientX, first.clientY, false,
                                  false, false, false, 0/*left*/, null);

    first.target.dispatchEvent(simulatedEvent);
}

function mouseX(e: MouseEvent): number {
  if (e.pageX) {
    return e.pageX;
  }
  if (e.clientX) {
    return e.clientX + (document.documentElement.scrollLeft ?
      document.documentElement.scrollLeft :
      document.body.scrollLeft);
  }
  return -1;
}

function mouseY(e: MouseEvent): number {
  if (e.pageY) {
    return e.pageY;
  }
  if (e.clientY) {
    return e.clientY + (document.documentElement.scrollTop ?
      document.documentElement.scrollTop :
      document.body.scrollTop);
  }
  return -1;
}

function dragable(element: HTMLElement, unique_id: string) {

  let drag = false;
  let offsetX = 0;
  let offsetY = 0;
  let mousemoveTemp: any = null;

  if (element) {

    document.addEventListener('touchstart', touchHandler, {capture: true, passive: true});
    document.addEventListener('touchmove', touchHandler, {capture: true, passive: true});
    document.addEventListener('touchend', touchHandler, {capture: true, passive: true});
    document.addEventListener('touchcancel', touchHandler, {capture: true, passive: true});

    const left = localStorage.getItem('notification_' + unique_id + '_left');
    const top = localStorage.getItem('notification_' + unique_id + '_top');

    if (left !== null && left !== '' && top !== null && top !== '') {
        element.style.left = left;
        element.style.top = top;
    } else {
      // No previous save. Lets randomise position
      // const height = $(window).height();   // returns height of browser viewport
      // const width = $(window).width();     // returns width of browser viewport

      const width = window.screen.availWidth;   // returns width of browser viewport
      const height = window.screen.availHeight;     // returns height of browser viewport

      element.style.left = Math.random() * (width - 100) + 'px';
      element.style.top = Math.random() * (height - 200) + 'px';
    }

    const move = (x: number, y: number): void => {

      DEFAULT_Z_INDEX = DEFAULT_Z_INDEX + 1;
      element.style.zIndex = DEFAULT_Z_INDEX.toString();
      if (!element.style.left || !element.style.top) {
        return;
      }
      element.style.left = (parseInt(element.style.left, 10) + x) + 'px';
      element.style.top  = (parseInt(element.style.top, 10) + y) + 'px';
    };

    const mouseMoveHandler = (e: MouseEvent): boolean => {
      e = e || window.event;

      if (!drag) {return true; }

      const x = mouseX(e);
      const y = mouseY(e);
      if (x !== offsetX || y !== offsetY) {
        move(x - offsetX, y - offsetY);
        offsetX = x;
        offsetY = y;
      }
      return false;
  };

    element.onmousedown = (e: MouseEvent): boolean => {
      e = e || window.event;

      offsetX = mouseX(e);
      offsetY = mouseY(e);
      drag = true; // basically we're using this to detect dragging

      // save any previous mousemove event handler:
      if (document.body.onmousemove) {
        mousemoveTemp = document.body.onmousemove;
      }
      document.body.onmousemove = mouseMoveHandler;
      return false;
  };


    element.onmouseup = (e: MouseEvent): boolean => {

      drag = false;

      // Save position
      if (element.style.left && element.style.top) {
        localStorage.setItem('notification_' + unique_id + '_left', element.style.left.toString());
        localStorage.setItem('notification_' + unique_id + '_top', element.style.top.toString());
      }

      // restore previous mousemove event handler if necessary:
      if (mousemoveTemp) {
        document.body.onmousemove = mousemoveTemp;
        mousemoveTemp = null;
      }
      return false;
  };

  }
}

@Component({
    components: {},
})
export default class Note extends Vue {

  @Prop() public unique_id!: string;
  @Prop() public colour!: string;

  private text: string = '';
  private visible: string = 'visible';

  public deleteNote() {

    this.visible = 'hidden';
    localStorage.removeItem('notification_' + this.unique_id + '_left');
    localStorage.removeItem('notification_' + this.unique_id + '_top');

    this.$emit('deleted', this.unique_id);
  }

  private mounted() {

    const element: Element = this.$refs.parent as Element;

    dragable(element as HTMLElement, this.unique_id);
  }
}
